import { memo, useCallback, useMemo } from 'react';
import {
  ImageElement,
  ImageStyleProperties
} from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Element/ImageElement';
import PlayerMenuTooltip from '@/App/remotion/components/PlayerMenus/PlayerMenuTooltip';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { classnames } from '@/libs/utils';
import { changeElementPositionHandler } from '@/Pages/Clip/ClipPlayer/ClipAssets/handlers';
import { DEFAULT_CONTAINER_STYLE } from '@/Pages/Clip/ClipPlayer/ClipAssets/constants';
import Icon from '@/components/atoms/Icon';

function ImageElementFill({ selectedElement }: { selectedElement: ImageElement }) {
  const { clipId, clipData } = useClipsContext();

  const currentFill = useMemo(() => selectedElement?.style?.objectFit, [selectedElement?.style?.objectFit]);

  const isFilled = useMemo(() => {
    return currentFill === 'cover';
  }, [currentFill]);

  const toggleBorderRadius = useCallback(() => {
    if (!selectedElement?.id) {
      return;
    }

    const newContainerStyle: ImageStyleProperties = isFilled
      ? { ...DEFAULT_CONTAINER_STYLE }
      : {
          width: '100%',
          height: '100%',
          top: 0,
          left: 0
        };

    const newStyle: ImageStyleProperties = {
      objectFit: isFilled ? 'contain' : 'cover'
    };

    changeElementPositionHandler(clipData, clipId, selectedElement.id, {
      containerStyle: newContainerStyle,
      style: newStyle
    });
  }, [clipId, selectedElement?.id, clipData, isFilled]);

  return (
    <button
      onClick={toggleBorderRadius}
      data-testid="image-element-fill-toggle"
      className={classnames('group/button flex size-10 items-center justify-center rounded-md')}
    >
      <Icon name="IconRectangle" size={20} />
      <PlayerMenuTooltip content="Fill frame" />
    </button>
  );
}

export default memo(ImageElementFill);
